<template>
  <div>
    <component
      v-for="fiador in fiadores"
      :key="fiador.id_pessoa"
      :is="getComponentByTipoPessoa(fiador.tipo_pessoa)"
      :pessoa="fiador"
      @click="handleClickAction"
      @save="handleSaveAction"
    />
    <v-layout row wrap pt-0>
      <v-flex xs3 align-center pt-0>
        <a
          href
          @click.prevent="
            $emit('click', { pessoa: null, categoria: 'FIADORES', pai: null })
          "
          class="proposta__blue-text mt-2"
        >
          <v-icon>add_circle</v-icon>Adicionar Fiador
        </a>
      </v-flex>
    </v-layout>
  </div>
</template>

<script lang="js">
export default {
  name: "TomadorCCGFiadores",

  
  computed: {
    fiadores() {
      return this.$store.state.ccg.ccg.fiadores;
    },
  },
  methods: {
    getComponentByTipoPessoa(tipo_pessoa) {
      return tipo_pessoa == "FISICA"
        ? "tomador-ccg-fiadores-fisica"
        : tipo_pessoa == "JURIDICA"
        ? "tomador-ccg-fiadores-juridica"
        : "tomador-ccg-fiadores-juridica";
    },
    handleClickAction(data) {
      this.$emit("click", data);
    },
    handleSaveAction(data, pessoa) {
      this.$emit("save", data, pessoa);
    },
  },
};
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorCCGFiadores.vue.vue